import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const propertyHostService = {
  getAdmins,
  create,
  update,
};

// Owner/admin users of a property merged with their host row (display labels).
function getAdmins(propertyId) {
  return (
    axios
      .get(`${apiEndpoint.propertyHosts}/admins?property_id=${propertyId}`, { headers: authHeader() })
      .then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
        return {};
      })
  );
}

function create(data) {
  return (
    axios
      .post(apiEndpoint.propertyHosts, data, { headers: authHeader() })
      .then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
        return {};
      })
  );
}

function update(id, data) {
  return (
    axios
      .put(`${apiEndpoint.propertyHosts}/${id}`, data, { headers: authHeader() })
      .then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
        return {};
      })
  );
}
